﻿import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get values() {
        return {
            entityType: String,
            entityId: String,
            targetUrl: String
        };
    }

    connect() {
        this.element.addEventListener("click", e => this.logUserAction(e));
    }

    async logUserAction(e) {
        await fetch(
            "/UserAction/Log",
            {
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    entityType: this.entityTypeValue,
                    entityId: this.entityIdValue,
                    targetUrl: this.targetUrlValue
                })
            }
        );
    }
}